// NPM
import React from 'react'
import _ from 'lodash'

// Shared components
import Description from 'src/components/Shared/Description'

const Tweet = ({ tweet, linkText }) => {

  if(!tweet) {
    return null
  }

  return (
    <div className="Tweet">
      <p 
        className="Tweet__content" 
        dangerouslySetInnerHTML={{__html: _.get(tweet, 'content.data.content')}} 
      />

      <div className="Tweet_bottom">
        <div className="Tweet__handle-holder">
          <img 
            className="Tweet__icon" 
            src={ require("src/images/logos/twitter-blue.png").default }
          />

          <a 
            className="Tweet__handle"
            href={ `https://twitter.com/@${ tweet.twitterHandle }` }
            target="__blank">
              @{ tweet.twitterHandle }
          </a>
        </div>

        <a 
          className="Tweet__link"
          href={ tweet.url }
          target="__blank">
            { linkText }
        </a>
      </div>
    </div>
  )
}

export default Tweet;